import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1201Model } from '../kymw1201.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { CatalogInfo } from '../vo/catalog-info.model';

// レスポンス構造
export type GetCatalogInfoResponse = {
  CatalogInfo: {
    /** 前企画回（M月N回） */
    PreviousCatalogId: string;
    /** 前企画回に対応する受注コード */
    PreviousOrderCode: string;
    /** 前企画確定フラグ */
    PreviousCatalogFixFlg: string;
    /** 企画回（M月N回） */
    CatalogId: string;
    /** 受注コード */
    OrderCode: string;
    /** 企画確定フラグ */
    CatalogFixFlg: string;
    /** 次企画回（M月N回） */
    NextCatalogId: string;
    /** 次企画回に対応する受注コード */
    NextOrderCode: string;
    /** 次企画確定フラグ */
    NextCatalogFixFlg: string;
  };
};

/**
 * 企画回情報取得処理サービス
 * @export GetCatalogInfo
 * @class GetCatalogInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCatalogInfo extends PlessJsonResponderSub<GetCatalogInfoResponse> {
  private model: KYMW1201Model;
  private orderCode: string;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CatalogInfo: {
          condition: {
            OrderCode: this.orderCode,
          }
        }
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param orderCode
   * @memberof GetCatalogInfo
   */
  execute(model: KYMW1201Model, orderCode: string, f: () => void = null): void {
    this.model = model;
    this.orderCode = orderCode;
    this.calbak = f;
    this.send('KYMW12getCatalogInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogInfo
   */
  success(data: GetCatalogInfoResponse) {
    this.model.catalogInfo = new CatalogInfo(
      data.CatalogInfo.PreviousCatalogId,
      data.CatalogInfo.PreviousOrderCode,
      data.CatalogInfo.PreviousCatalogFixFlg,
      data.CatalogInfo.CatalogId,
      data.CatalogInfo.OrderCode,
      data.CatalogInfo.CatalogFixFlg,
      data.CatalogInfo.NextCatalogId,
      data.CatalogInfo.NextOrderCode,
      data.CatalogInfo.NextCatalogFixFlg,
    );
    this.model.orderCode = data.CatalogInfo.OrderCode;
    this.model.prevDisabled = data.CatalogInfo.PreviousOrderCode === '';
    this.model.nextDisabled = data.CatalogInfo.NextOrderCode === '';
    if (this.calbak) this.calbak();
  }
}
